import { FetchContext } from '../fetch-context';
import { WinnerContact } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const updateWinnerContact: (
  fetchContext: FetchContext,
  questionnaireId: number, 
  winnerContact: WinnerContact,
  accessToken?: string,
) => Promise<void> = (fetchContext, questionnaireId, winnerContact, accessToken) => {
  return fetch(`${fetchContext.baseUrl}/api/questionnaires/${questionnaireId}/contact`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(winnerContact),
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update winner contact'));
};
